module.exports = __webpack_public_path__ + "img/loader.59265d20.svg";